export const LAST_SESSION = 'LAST_SESSION';
export const DIRECT_CALL = 'directcall';
export const AGENT = 'agent';
